<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" v-on:click.stop>
        <div class="modal-container collecte-modal">

          <div class="modal-header">
            <h1>Importer des Rondes en masse</h1>
            <div class="btn btn-primary" v-on:click=closeModal><i class="fa fa-times" aria-hidden="true"></i></div>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: [
    'title',
  ],
  computed: {
    ...mapState([
      'rondes'
    ]),
  },
  methods: {
    closeModal: function () {
      this.rondes.importModal.visible = false
    }
  },
}
</script>

<style lang="scss">
@import "../../../scss/variables";

.modal-mask {
  position:fixed;
  z-index:9999;
  top:0; left:0; right:0; bottom:0;
  background-color:rgba($suez-blue, 0.5);
  display:flex;
  align-items:center;
  justify-content:center;

  .modal-wrapper {
    background-color:white;
    min-width:600px;
    max-height:90vh;
    color:$suez-blue;

    .modal-container {
      position:relative;

      .modal-body {
        position:static;
        max-width:80vw;
        max-height:70vh;
        overflow:scroll;

        .buttons {
          text-align:right;
          padding:1.2rem;
          margin-top:2rem;
        }
      }

      .modal-header {
        position:relative;
        border-bottom:none;
        background-color:rgba($suez-blue, .05);
        margin-bottom:1rem;

        h1 {
          margin:0;
          text-align:left;
        }

        div.btn {
          position:absolute;
          top:0;
          right:0;
          border-radius:0px;
        }
      }
    }
  }
}


.modal-mask {
  .modal-wrapper {
    .modal-container {
      .modal-body {
        overflow: auto;
      }
      .modal-header {
        background-color: white;
      }
    }
  }
}

.collecte-modal {
  height: 90%;
  width: 800px;
}
</style>



// WEBPACK FOOTER //
// RondesImportModal.vue?ebed217a